import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinterHoardGameModuleConfig} from "../WinterHoardGameModuleConfig";

export class REWinFieldController extends WinFieldController {
    public showWinField(to?:number, forceWin:boolean = false, forceTotalWin:boolean = false):void {
        if(this.shouldShow()) {
            to = to != null ? to : this._totalWin;

            if(!forceWin && (forceTotalWin || this._shouldShowTotalWin || this._shouldNextShowTotalWin)) {
                SlotGame.keypad.setWin(to, true, WinterHoardGameModuleConfig.featurePrice.isWinBelowStake());
                return;
            }
            SlotGame.keypad.setWin(to);
        }
    }
}